import { markGetter } from '@/services/general/map/markersGetter';
import getLogo from '@/services/general/getLogo';

export const ACTION_ADD_SELECTION = 'ACTION_ADD_SELECTION';
export const ACTION_DELETE_SELECTION = 'ACTION_DELETE_SELECTION';
export const ACTION_APPLY_COLOR = 'ACTION_APPLY_COLOR';

function isValidAdresse(adresse) {
  return adresse && adresse.lagitude !== null && adresse.longitude !== null;
}

export const TYPE_MARKERS = [
  {
    type: 'produitFaces',
    slot: 'produitFaces',
    convertToMarker: async (produit, options) => {
      const mark = await markGetter(
        produit.produitFace.adresse,
        produit.color,
        options.withAzimut ? produit.produitFace.azimut : null,
      );
      mark.type = 'produitFaces';
      mark.produitId = produit.id;
      mark.clickable = options.clickable;
      mark.produit = produit;
      mark.societeId = produit.supportCommercial?.societeId;
      return mark;
    },
    isValid: (produit) => {
      return isValidAdresse(produit?.produitFace?.adresse);
    },
  },
  {
    type: 'produitEcrans',
    slot: 'produitEcrans',
    convertToMarker: async (produit, options) => {
      const mark = await markGetter(
        produit.produitEcranNumerique.adresse,
        produit.color,
        options.withAzimut ? produit.produitEcranNumerique.azimut : null,
      );
      mark.type = 'produitEcrans';
      mark.produitId = produit.id;
      mark.clickable = options.clickable;
      mark.produit = produit;
      mark.societeId = produit.supportCommercial?.societeId;
      return mark;
    },
    isValid: (produit) => {
      return isValidAdresse(produit?.produitEcranNumerique?.adresse);
    },
  },
  {
    type: 'clients',
    slot: 'clients',
    convertToMarker: async (client, options) => {
      const logo = await getLogo(client.id);
      const mark = await markGetter(
        client.adressePostale,
        client.color,
        null,
        logo,
      );
      mark.type = 'clients';
      mark.id = client.id;
      mark.clickable = options.clickable;
      mark.client = client;
      return mark;
    },
    isValid: (client) => {
      return isValidAdresse(client?.adressePostale);
    },
  },
  {
    type: 'reseaux',
    slot: 'produitFaces',
    convertToMarker: async (reseau, options) => {
      if (
        !reseau?.produitReseau?.affectationsReseauFace
        || !Array.isArray(reseau.produitReseau.affectationsReseauFace)
      ) return [];
      const faces = reseau.produitReseau.affectationsReseauFace
        .filter(f => isValidAdresse(f?.produit?.produitFace?.adresse))
        .map(face => {
          return new Promise((resolve) => {
            markGetter(
              face?.produit?.produitFace?.adresse,
              reseau.color,
              options.withAzimut ? face?.produit?.produitFace?.azimut : null,
            ).then(mark => {
              mark.type = 'produitFaces';
              mark.produitId = face?.produitId;
              mark.clickable = options.clickable;
              mark.produit = face.produit;
              mark.reseau = reseau.libelle;
              mark.societeId = reseau.supportCommercial?.societeId;
              resolve(mark);
            });
          });
        });
      const result = await Promise.all(faces);
      return result;
    },
    isValid: (reseau) => {
      return reseau.produitReseau?.affectationsReseauFace?.length > 0;
    },
  },
];
